import axios, { CancelToken } from 'axios';
import { REFRESH_INTERVAL } from '../constants';

export default class Api {
  static CancelError = class CancelError extends Error {};

  constructor(route, method = 'get') {
    this.route = route;
    this.requestBody = null;
    this.method = method;
    this.timeouts = [];
    this.cancellers = [];
    this.isPaused = false;
    this.pageVisibility = { // Page Visibility API
      prop: 'hidden',
      event: 'visibilitychange',
    };

    this.addEventListeners();
  }

  addEventListeners() {
    if (typeof document.hidden === 'undefined') {
      if (typeof document.msHidden !== 'undefined') {
        this.pageVisibility.prop = 'msHidden';
        this.pageVisibility.event = 'msvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        this.pageVisibility.prop = 'webkitHidden';
        this.pageVisibility.event = 'webkitvisibilitychange';
      }
    }

    this.toggleVisibilityListener(true);
  }

  toggleVisibilityListener(state) {
    document[state ? 'addEventListener' : 'removeEventListener'](
      this.pageVisibility.event,
      this.handleVisibilityChange,
      false
    );
  }

  // Do not use `bind()` with this or `removeEventListener` will not work
  handleVisibilityChange = () => {
    this.isPaused = document[this.pageVisibility.prop];
    if (!this.isPaused) this.fetch(); // Resume
  }

  getNewCancelToken() {
    const canceller = CancelToken.source();
    this.cancellers.push(canceller);

    return canceller.token;
  }

  async start({ onBefore, onSuccess, onError, requestBody }) {
    Object.assign(this, { onBefore, onSuccess, onError, requestBody });
    return await this.fetch();
  }

  async fetch() {
    try {
      if (this.isPaused) return false;
      this.timeouts.forEach(clearTimeout);
      if (typeof this.onBefore === 'function') this.onBefore();
      const { data } = await axios({
        method: this.method,
        url: this.route,
        cancelToken: this.getNewCancelToken(),
        data: this.requestBody,
      });
      if (typeof this.onSuccess === 'function') this.onSuccess(data);
      this.queue();
    } catch (e) {
      const isCancelled = axios.isCancel(e);
      if (typeof this.onError === 'function') this.onError(isCancelled ? new Api.CancelError(e) : e);
      if (!isCancelled) this.queue();
    }
  }

  queue() {
    if (this.isPaused) return false;
    this.timeouts.push(setTimeout(this.fetch.bind(this), REFRESH_INTERVAL));
  }

  stop() {
    this.timeouts.forEach(clearTimeout);
    this.cancellers.forEach(c => c.cancel());
    this.toggleVisibilityListener(false);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/Api.js